document.addEventListener('DOMContentLoaded', () => {
    const menuButton = document.querySelector('.header__menu');
    const menuButtonClose = document.querySelector('.header__menu-close');
    const mobileMenu = document.querySelector('.mobile-menu');
    const popupTrigger = document.querySelector('.get-call');
    const popup = document.querySelector('.vacancy-coll-popup');
    const closeColl = document.querySelector('.close-coll');

    const toggleMenu = () => {
        mobileMenu.classList.toggle('open-menu');
        menuButton.classList.toggle('hide-ico');
        menuButtonClose.classList.toggle('show-close');
        document.body.classList.toggle('app--fix');
    };
    window.togglePopup = () => {
        popup.classList.toggle('show-popup');
        document.body.classList.toggle('app--fix');
    }

    const closeMenu = () => {
        mobileMenu.classList.remove('open-menu');
        menuButton.classList.remove('hide-ico');
        menuButtonClose.classList.remove('show-close');
        document.body.classList.remove('app--fix');
    };

    menuButton.addEventListener('click', toggleMenu);
    menuButtonClose.addEventListener('click', toggleMenu);

    document.querySelectorAll('.dropdown-menu__mobile a').forEach(link => {
        link.addEventListener('click', closeMenu);
    });
    popupTrigger.addEventListener('click', window.togglePopup);
    closeColl.addEventListener('click', window.togglePopup);


});
